import RightClickContextMenu from './rightClickContextMenu.view';

export default RightClickContextMenu;
